import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import ThreeImg from '../threeImg';
import BigImg from '../bigImg';
import News from '../news';

class MainInfo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        pageInfo: PropTypes.object,
        fromPage: PropTypes.string,
    };

    render() {
        const { content, pageInfo, fromPage } = this.props;
        const {
            link,
            sub_name,
            doc_name,
            style,
            doc_thumbnail,
            comment_id,
            comment_contents,
            share_url,
            comment_relation,
            thumbnail,
            title,
        } = content;

        const weburl = link ? link.weburl : '';
        const type = link ? link.type : '';

        // const { type, weburl } = link;
        // const { images } = style;

        // const threeImgData = {
        //     comment_contents,
        //     sub_name,
        //     doc_name,
        //     images: thumbnail,
        //     share_url,
        //     weburl,
        //     isOnClickDocTitle: true,
        //     clickCount: {
        //         behavior: 'action',
        //         type,
        //         other: {
        //             id: comment_id,
        //             ref: encodeURIComponent(document.referrer),
        //             url: weburl,
        //         },
        //     },
        //     pageInfo,
        // };

        // const bigImgData = {
        //     comment_contents,
        //     sub_name,
        //     doc_name,
        //     doc_thumbnail: thumbnail,
        //     share_url,
        //     weburl,
        //     isOnClickDocTitle: true,
        //     clickCount: {
        //         behavior: 'action',
        //         type: 'comtmore',
        //         other: {
        //             id: comment_id,
        //             url: weburl,
        //             kind: 'video',
        //         },
        //     },
        //     pageInfo,
        // };

        const newsData = {
            doc_name: doc_name || title,
            doc_thumbnail: doc_thumbnail || thumbnail,
            share_url,
            weburl,
            sub_name,
            comment_contents,
            pageInfo,
            isOnClickDocTitle: true,
            comment_relation,
            fromPage,
        };

        return (
            <div>
                {/* {type === 'slide' ? <ThreeImg content={threeImgData} /> : ''}
                {type === 'phvideo' ? <BigImg content={bigImgData} /> : ''}
                {type === 'doc' ? <News content={newsData} /> : ''} */}
                <News content={newsData} />
            </div>
        );
    }
}

export default errorBoundary(MainInfo);
